import {
  getRequest,
  postBlobRequest,
  postRequest,
  putRequest,
} from "./config/request";
const SERVICE_URL = "/purchase-order/goods-receive-note";

export const create = (data: any[]) => postRequest(`${SERVICE_URL}/`, data);
export const createMultiple = (data: any[]) =>
  postRequest(`${SERVICE_URL}/multiple`, data);
export const paginate = (qs: string) => getRequest(`${SERVICE_URL}?${qs}`);
export const get = (id: string) => getRequest(`${SERVICE_URL}/${id}`);
export const updatePurchasePriceForProductCode = (data: any) =>
  putRequest(`${SERVICE_URL}/purchase-price`, data);
export const generateVendorChallanID = (vendorId: string) =>
  getRequest(`${SERVICE_URL}/vendor-challan-id/${vendorId}`);
export const update = (data: any) => putRequest(`${SERVICE_URL}/`, data);
export const voidGRN = (id: string) => putRequest(`${SERVICE_URL}/void/${id}`);
export const getSummaryReport = (duration) =>
  postRequest(`${SERVICE_URL}/report/summary`, { duration });
export default {
  create,
  paginate,
  get,
  createMultiple,
  updatePurchasePriceForProductCode,
  generateVendorChallanID,
  update,
  voidGRN,
  getSummaryReport,
};
